import React, { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import { MessageInfo } from './InternalMessageSendDetailPageStyled'
import moment from 'moment'
import { DATE_FORMAT_SLASH, HH_mm } from '../../../constants'
import NormalTag from '../../../components/NormalTag/NormalTag'
import {
  message as antdMessage,
  Avatar,
  Button,
  Form,
  Input,
  Layout,
  List,
  message,
  Typography,
  Upload,
} from 'antd'
import { Dialog, useTheme } from '@mui/material'
import utils from '../../../utils'
import { systemName } from '../../../config'
import {
  EmptyText,
  subStringAvatar,
  TitleContentBox,
  WordBreak,
} from '../../../components/common/CellText'
import { apiUrl } from '../../../config'
import { useLocation, useNavigate } from 'react-router-dom'
import { IoArrowBack } from 'react-icons/io5'
import { MdAttachFile, MdSend } from 'react-icons/md'
import { FaInfoCircle } from 'react-icons/fa'
import {
  InfoOutlined,
  PhoneOutlined,
  UploadOutlined,
  VerifiedUserOutlined,
  VideoCameraBackOutlined,
} from '@mui/icons-material'
import UploadFileItem from '../../../components/FileItemComponent/UploadFileItem'
import { UploadFileListWrapper } from '../InternalMessageCreateModalStyled'
import FileItem from '../../../components/FileItemComponent/FileItem'

const { Header, Content, Footer } = Layout
const { Text } = Typography

const InternalMessageSendDetailPage = props => {
  const {
    userStore,
    loadingAnimationStore,
    authenticationStore,
    userWithImageId,
    fetchInternalMessage,
    internalMessageDetail,
    internalMessageStore,
    isReceive = true,
    fileStore,
  } = props
  const { currentUser } = authenticationStore
  const messagesEndRef = React.useRef(null)
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()
  const code = location.pathname.split('/').pop()
  const [form] = Form.useForm()
  const [newMessage, setNewMessage] = useState('')
  const [showTimestamp, setShowTimestamp] = useState({})
  const [fileList, setFileList] = useState([])
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    scrollToBottom()
  }, [internalMessageDetail])

  const handleChangeFile = info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const sendComment = async value => {
    const uploadFileList = fileList
      ? fileList.map(file => file.originFileObj)
      : []
    const batchUploadArr = []
    if ((isReceive && !code) || (isReceive && !internalMessageDetail.code)) {
      return message.warning('Không tìm thấy tin nhắn cần trả lời')
    }
    loadingAnimationStore.showSpinner(true)
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    let uploadedFiles = []
    try {
      const response = await Promise.all(batchUploadArr)
      uploadedFiles = response.map(response => response.data.file_id)
      const messageData = {
        content: newMessage,
        file_ids: uploadedFiles,
        owner: currentUser?.userName,
        owner_name: currentUser?.fullName,
        parent_code: internalMessageDetail.code,
      }
      await internalMessageStore.create(messageData)
      fetchInternalMessage()
      await internalMessageStore.getSendMessageById(internalMessageDetail.code)

      setFileList([])
      form.resetFields()
      setNewMessage('')
      // message.success('Gửi phản hồi thành công!')
    } catch (err) {
      // console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  // Hàm chuyển đổi hiển thị thời gian cho từng tin nhắn
  const toggleTimestamp = messageId => {
    setShowTimestamp(prevState => ({
      ...prevState,
      [messageId]: !prevState[messageId],
    }))
  }

  const updatedMessagesDetail = {
    ...internalMessageDetail,
    image_id: userWithImageId?.find(
      user => user.username === internalMessageDetail.owner
    )?.image_id,
  }

  const toTitleCase = str => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  }
  const getImageIdbyName = name => {
    const user = userWithImageId?.find(user => user.username === name)
    return user?.image_id
  }

  return (
    <>
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <ContentBlockWrapper>
          <TitleContentBox>Thông tin</TitleContentBox>
          <MessageInfo>
            <dt>Người gửi</dt>
            <dd>
              <div className={'assign'}>
                {internalMessageDetail.owner_name ? (
                  <NormalTag
                    noHover={true}
                    showFullTag={false}
                    tags={[{ name: internalMessageDetail.owner_name }].map(
                      user =>
                        utils.getNameInCapitalize(user?.name?.toLowerCase())
                    )}
                  />
                ) : (
                  <EmptyText>Không rõ.</EmptyText>
                )}
              </div>
            </dd>
            <dt>Người nhận</dt>
            <dd>
              <div className="flex flex-wrap gap-3">
                {internalMessageDetail.receiver ? (
                  internalMessageDetail.receiver.map(user => (
                    <NormalTag
                      noHover={true}
                      showFullTag={false}
                      tags={[{ name: user.fullname }].map(user =>
                        utils.getNameInCapitalize(user?.name?.toLowerCase())
                      )}
                    />
                  ))
                ) : (
                  <EmptyText>Không rõ.</EmptyText>
                )}
              </div>
            </dd>
            <dt>Ngày gửi</dt>
            <dd>
              {internalMessageDetail.created_time ? (
                `${moment(internalMessageDetail.created_time).format(
                  DATE_FORMAT_SLASH
                )} - ${moment(internalMessageDetail.created_time).format(
                  HH_mm
                )}`
              ) : (
                <EmptyText>Không rõ.</EmptyText>
              )}
            </dd>
            <dt>Nội dung</dt>
            <dd>
              {internalMessageDetail.content ? (
                WordBreak(internalMessageDetail.content, true)
              ) : (
                <EmptyText>Không rõ.</EmptyText>
              )}
            </dd>
            <dt>Tài liệu đính kèm</dt>
            <dd>
              {internalMessageDetail.file_ids?.length > 0 ? (
                internalMessageDetail.file_ids.map(file => (
                  <FileItem
                    key={file.file_id}
                    file_id={file.file_id}
                    file_name={file.name}
                    file_type={utils.getExtensionFile(file.name)}
                  />
                ))
              ) : (
                <EmptyText>Không có.</EmptyText>
              )}
            </dd>
          </MessageInfo>
        </ContentBlockWrapper>
      </Dialog>

      <Layout style={{ height: '100vh' }}>
        <Header
          style={{
            background: '#fff',
            padding: '0 16px',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <IoArrowBack
              size={28}
              color="black"
              className="flex-shrink-0 hover:text-[#2C65AC] mr-4"
              onClick={() => navigate(-1)}
            />
            <Avatar
              style={{
                backgroundColor: '#2C65AC',
                fontSize: 18,
                border: 'none',
              }}
              src={
                updatedMessagesDetail.image_id
                  ? `${apiUrl}/api/v1/images/${updatedMessagesDetail.image_id}`
                  : null
              }
              size="large">
              {updatedMessagesDetail.image_id ? null : (
                <div>{subStringAvatar(updatedMessagesDetail.owner_name)}</div>
              )}
            </Avatar>
            <Text
              strong
              style={{ marginLeft: 16, fontSize: 18 }}
              className="max-w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap"
              ellipsis={{ tooltip: updatedMessagesDetail.title }}>
              {updatedMessagesDetail.title}
            </Text>
          </div>
          <div className="flex items-center justify-end absolute right-0">
            <Button
              className="border-none flex items-center justify-center"
              onClick={() => setIsDialogOpen(true)}>
              <svg
                className="w-8 h-8"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64">
                <path
                  d="M32,6C17.641,6,6,17.641,6,32c0,14.359,11.641,26,26,26s26-11.641,26-26C58,17.641,46.359,6,32,6z M32.021,16 C33.555,16,35,17.346,35,18.981C35,20.727,33.555,22,32.021,22C30.225,22,29,20.727,29,18.981C29,17.346,30.225,16,32.021,16z M39,47h-5h-4h-5v-3l5-1V30h-4v-3l8-1v17l5,1V47z"
                  fill="#2C65AC"></path>
              </svg>
            </Button>
          </div>
        </Header>
        <Content style={{ padding: '18px', overflowY: 'auto' }}>
          <List
            dataSource={internalMessageDetail?.reply_internal_messages || []}
            renderItem={message => (
              <List.Item
                style={{
                  display: 'flex',
                  justifyContent:
                    message.owner === currentUser.username
                      ? 'flex-end'
                      : 'flex-start',
                  marginBottom: 16, // Khoảng cách giữa các tin nhắn
                  border: 'none',
                  padding: 12,
                  borderRadius: 16,
                }}>
                <div
                  style={{
                    maxWidth: '70%',
                    display: 'flex',
                    flexDirection:
                      message.owner === currentUser.username
                        ? 'row-reverse'
                        : 'row',
                  }}>
                  <Avatar
                    src={
                      getImageIdbyName(message.owner)
                        ? `${apiUrl}/api/v1/images/${getImageIdbyName(
                            message.owner
                          )}`
                        : null
                    }
                    size="large"
                    style={{
                      backgroundColor: '#2C65AC',
                      marginRight:
                        message.owner === currentUser.username ? 0 : 5,
                      marginLeft:
                        message.owner === currentUser.username ? 5 : 0,
                    }}>
                    {!getImageIdbyName(message.owner) && (
                      <div>{subStringAvatar(message.owner_name)}</div>
                    )}
                  </Avatar>

                  <div
                    className={`${
                      message.owner === currentUser.username
                        ? 'bg-blue-100'
                        : 'bg-white'
                    } rounded-[16px] p-4`}
                    style={{
                      // backgroundColor: '#fff', // Màu nền xanh cho tên và nội dung
                      color: '#fff', // Màu chữ trắng trên nền xanh
                      padding: '8px 12px',
                      borderRadius: 16,
                      borderBottomLeftRadius:
                        message.owner === currentUser.username ? 16 : 2,
                      borderBottomRightRadius:
                        message.owner === currentUser.username ? 2 : 16,
                      wordBreak: 'break-word', // Đảm bảo từ dài sẽ xuống dòng
                    }}>
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#000',
                      }}>
                      {toTitleCase(message.owner_name)}
                    </div>
                    <Text style={{ display: 'block', marginTop: 4 }}>
                      {message.content}
                    </Text>

                    {showTimestamp[message.id] && (
                      <Text
                        type="secondary"
                        style={{
                          fontSize: 12,
                          color: '#fff', // Màu chữ thời gian là trắng
                          marginTop: 4,
                          display: 'block',
                          textAlign:
                            message.owner === currentUser.username
                              ? 'right'
                              : 'left',
                        }}>
                        {moment(message.created_time).format(
                          'DD/MM/YYYY HH:mm'
                        )}
                      </Text>
                    )}

                    {message.file_ids?.length > 0 &&
                      message.file_ids.map(file => (
                        <FileItem
                          key={file.file_id}
                          file_id={file.file_id}
                          file_name={file.name}
                          file_type={utils.getExtensionFile(file.name)}
                          fileStyle={{
                            color: '#000',
                            padding: '4px 8px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '170px',
                            marginTop: 4,
                          }}
                        />
                      ))}
                  </div>
                </div>
              </List.Item>
            )}
          />

          <div ref={messagesEndRef} />
        </Content>
        <Footer
          style={{
            padding: '8px 16px',
            background: '#fff',
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Form
            onFinish={sendComment}
            layout="inline"
            style={{ display: 'flex', alignItems: 'start', width: '100%' }}>
            <Form.Item style={{ flex: 1, margin: 0 }} name={'content'}>
              <Input
                id="message-input"
                placeholder="Aa"
                value={newMessage}
                onChange={e => setNewMessage(e.target.value)}
                bordered={false}
                style={{
                  width: '100%',
                  backgroundColor: '#f0f4ff',
                  color: '#000',
                  padding: '8px 12px',
                  borderRadius: '16px',
                  border: '1px solid #3A86FF',
                  boxShadow: '0px 2px 8px rgba(58, 134, 255, 0.2)',
                }}
              />
              {fileList.length !== 0 && (
                <UploadFileListWrapper>
                  {fileList.map(file => (
                    <UploadFileItem
                      key={file.uid}
                      file_id={file.uid}
                      file_name={file.name}
                      file_type={utils.getExtensionFile(file.name)}
                      handleRemoveFileFromUploadList={() =>
                        handleRemoveFileFromUploadList(file.uid)
                      }
                    />
                  ))}
                </UploadFileListWrapper>
              )}
            </Form.Item>
            <Form.Item style={{ margin: 0, textAlign: 'start' }}>
              <Upload
                valuePropName={'fileList'}
                fileList={fileList}
                multiple={true}
                onChange={handleChangeFile}
                beforeUpload={() => false}
                showUploadList={false}>
                <Button
                  type="text"
                  className="flex items-center justify-center bg-[rgba(0,0,0,-0.1)] rounded-lg"
                  style={{ padding: '0 3px', marginTop: '5px' }}>
                  <MdAttachFile style={{ color: '#3A86FF', fontSize: 22 }} />
                </Button>
              </Upload>
            </Form.Item>
            <Form.Item style={{ margin: 0 }}>
              <Button
                type="text"
                htmlType="submit"
                className="flex items-center justify-center bg-[rgba(0,0,0,-0.1)]"
                style={{ padding: '0 3px', marginTop: '5px' }}>
                <MdSend style={{ color: '#3A86FF', fontSize: 20 }} />
              </Button>
            </Form.Item>
          </Form>
        </Footer>
      </Layout>
    </>
  )
}

export default inject(
  'loadingAnimationStore',
  'userStore',
  'authenticationStore',
  'fileStore',
  'internalMessageStore'
)(observer(InternalMessageSendDetailPage))
